import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { SpecialPricingOrderType } from '../enums/special-pricing-order-type.enum';
import { MouldingType } from '../enums/moulding-type.enum';
const routes = {
  products: () => 'product'
}
@Injectable({
  providedIn: 'root'
})
export class ProductService {
  constructor(private apiService: ApiService) { }

  getProductsPaginated(model: any): Observable<any> {
 
    return this.apiService.post(`${routes.products()}/GetPaginated`,model);
  }
  getFilters(): Observable<any> {
    return this.apiService.get(`${routes.products()}/GetFilters`)
  }
  getById(id: number): Observable<any> {

    return this.apiService.get(`${routes.products()}/GetDetails/${id}`);
  }
  getPrice(userId: number, inventoryItemId: number, currency: string, ui: number, mouldingType: MouldingType, quantity: number, orderType: SpecialPricingOrderType) {
    return this.apiService.get(`${routes.products()}/GetProductPrice?userId=${userId}&inventoryItemId=${inventoryItemId}&currency=${currency}&ui=${ui}&mouldingType=${mouldingType}&quantity=${quantity}&orderType=${orderType}`);
    }
  getStockLevel(id: number): Observable<any> {

    return this.apiService.get(`${routes.products()}/GetProductStockLevel?productId=${id}`);
  }
  getProductCategories(): Observable<any> {

    return this.apiService.get(`${routes.products()}/GetProductCategories`);
  }
}
